<div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
        <ng-container matColumnDef="star" stickyEnd>
            <th class="opCol" mat-header-cell *matHeaderCellDef></th>
            <td class="opCol" mat-cell *matCellDef="let element">
                <!-- <button mat-icon-button [routerLink]="['/users', element.id]">
        <mat-icon>remove_red_eye</mat-icon>
      </button> -->
                <!-- <button mat-icon-button (click)="removeElemet(element)">
        <mat-icon>delete</mat-icon>
      </button> -->
            </td>
        </ng-container>

        <!-- <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
            <td mat-cell *matCellDef="let row"> {{row.id}} </td>
        </ng-container> -->

        <ng-container matColumnDef="roadbook_id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Roadbook </th>
            <td mat-cell *matCellDef="let row"> {{getRoadbookName(row.roadbook_id)}} </td>
        </ng-container>

        <ng-container matColumnDef="device_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Device </th>
            <td mat-cell *matCellDef="let row"> {{row.device_name }} </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element" [attr.colspan]="3">
                <div class="example-element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                    <div class="container" style="padding: 20px;">
                        <mat-card style="background-color: #e9e9e9">
                            <div><span style="font-weight: bold;">Id: </span>{{element.id}} </div>
                            <div><span style="font-weight: bold;">Roadbook id: </span>{{getRoadbookName(element.roadbook_id)}} </div>
                            <div><span style="font-weight: bold;">Order line id: </span>{{element.orderline_id}} </div>
                            <div><span style="font-weight: bold;">Device id: </span>{{element.device_id}} </div>
                            <div><span style="font-weight: bold;">Device name: </span>{{element.device_name}} </div>
                            <div><span style="font-weight: bold;">Download date: </span>{{element.download_date.toDate()}} </div>
                            <div><span style="font-weight: bold;">Number of downloads: </span>{{element.num_downloads}} </div>
                        </mat-card>
                    </div>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="example-element-row" [class.example-expanded-row]="expandedElement === row" (click)="expandedElement = expandedElement === row ? null : row"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[25, 50, 100, 150]"></mat-paginator>
</div>